import { WebPlugin } from "@capacitor/core";
export class NavigationBarWeb extends WebPlugin {
    async setNavigationBarColor(options) {
        console.log("Cannot setNavigationBarColor on web", options);
        return;
    }
    async getNavigationBarColor() {
        console.log("Cannot getNavigationBarColor on web");
        return { color: "#000000" };
    }
}
//# sourceMappingURL=web.js.map